import { Table } from 'antd';
import styled from 'styled-components/macro';

const DataTable = styled(Table)`
  margin-top: 14px;
  margin-right: 2px;
`;

export default DataTable;
